import { render, staticRenderFns } from "./CustomsDoc.vue?vue&type=template&id=77863406&scoped=true"
import script from "./CustomsDoc.vue?vue&type=script&lang=js"
export * from "./CustomsDoc.vue?vue&type=script&lang=js"
import style0 from "./CustomsDoc.vue?vue&type=style&index=0&id=77863406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77863406",
  null
  
)

export default component.exports